import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BudgetTableContainer } from 'pages/calculator/MediaPlanning/common/BudgetTable/styles';
import { TableHeader } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import CountryInfoRow from '../CountryInfoRow/CountryInfoRow';
import usePlanStore from '../../../../../store/planStore';

interface CountryInfoTableProps {
  country: string;
}

function CountryInfoTable({ country }: CountryInfoTableProps) {
  const { t } = useTranslation();
  const { storedCountryForms } = usePlanStore();

  const tableHeaders: TableHeader[] = [
    { key: 'mediaPlanning.targetGroup', align: 'left' },
    { key: 'mediaPlanning.campaignScenario', align: 'left' },
    { key: 'mediaPlanning.segment', align: 'left' },
    { key: 'mediaPlanning.startDate', align: 'right' },
    { key: 'mediaPlanning.campaignLength', align: 'right' },
  ];

  const countryInfoRow = {
    targetGroup: storedCountryForms[country].targetGroup,
    campaignScenario: storedCountryForms[country].campaignScenario,
    segments: storedCountryForms[country].segments,
    startDate: storedCountryForms[country].startDate,
    campaignLength: storedCountryForms[country].campaignLength,
  };

  return (
    <Grid container sx={{ px: '15px' }}>
      <Grid item xs={12}>
        <Typography
          textTransform="uppercase"
          fontWeight={700}
          sx={{ pb: '12px' }}
        >
          {t('mediaPlanning.countrySetup')}
        </Typography>
        <BudgetTableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '34px' }} />
                {tableHeaders.map((header) => (
                  <TableCell
                    key={header.key}
                    align={header.align}
                    sx={{ width: header?.width || 'auto' }}
                  >
                    <Typography
                      variant="caption"
                      textTransform="uppercase"
                      fontWeight={600}
                    >
                      {t(header.key)}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <CountryInfoRow rowData={countryInfoRow} />
            </TableBody>
          </Table>
        </BudgetTableContainer>
      </Grid>
    </Grid>
  );
}

export default CountryInfoTable;
